module.exports = __webpack_public_path__ + "img/FPT19.891034b0.svg";